<app-core-select-group
    [configuration]="configuration"
    [sourceCallback]="sourceCallback"
    (selectionChange)="filter()"
></app-core-select-group>

